import { NgModule } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgOptionHighlightDirective } from '@ng-select/ng-option-highlight';

@NgModule({
  declarations: [],
  imports: [NgSelectModule, NgOptionHighlightDirective],
  exports: [NgSelectModule, NgOptionHighlightDirective],
})
export class TypeaheadModule {}

export type AddTagFn = (term: string) => any | Promise<any>;
